<template>
  <RouterView :key="$route.fullPath" />
</template>

<script>
import {
  LOAD_LOG_FOR_EMAIL
} from "./gamecamStore";

export default {
  name: "GamecamModule",

  props: {
    gamecamStorePath: {
      type: String,
      required: true
    },

    email: {
      type: String,
      required: true
    }
  },

  created() {
    const loadGamecamLogAction = `${this.gamecamStorePath}/${LOAD_LOG_FOR_EMAIL}`;
    const email = this.email;
    this.$store.dispatch(loadGamecamLogAction, { email });
  }
}
</script>

<style>

</style>
